import './styles.scss'
import React, { useMemo, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import _debounce from 'lodash.debounce'

import { filterChannelsTemplate } from 'api/marketing/templates'
import QualityStatus from '../QualityStatus'
import { InputControls } from 'components/common'
import { MultiBrandsAndDelegations } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const TemplateChannels = ({ channel, channelsData, templateChannels, setTemplateChannels }) => {
  const [channels, setChannels] = useState(channelsData || [])
  const [brandsAndDelegationsValue, setBrandsAndDelegationsValue] = useState({})
  const [searchValue, setSearchValue] = useState('')

  const onFilterBrandsAndDelegation = (values) => {
    setBrandsAndDelegationsValue(values)

    filterChannels({
      brands: values.brands,
      delegations: values.delegations,
      text: searchValue
    })
  }

  const onFilterText = (value) => {
    setSearchValue(value)

    filterChannels({
      brands: brandsAndDelegationsValue.brands,
      delegations: brandsAndDelegationsValue.delegations,
      text: value
    })
  }

  const filterChannels = useMemo(
    () => _debounce(async (params) => {
      const { brands, delegations, text } = params

      try {
        if (!brands?.length && !delegations?.length && !text) {
          setChannels(templateChannels)

          return
        }

        const parsedBrands = brands?.map(b => b.value) || []
        const parsedDelegations = delegations?.map(d => d.value) || []

        const { data } = await filterChannelsTemplate({
          channel,
          brands: parsedBrands,
          delegations: parsedDelegations,
          text
        })

        // varifica si la data ya esta asignada en templatesChannels y la retorna, sino devuelve la data obtenida de la peticion
        const newData = data.map(dataChannel => {
          const oneTemplate = templateChannels.find((temp) => temp.channelId === dataChannel.channelId)
          if(oneTemplate){
            return oneTemplate
          }
          return dataChannel
        })
        setChannels(newData || [])
      } catch(error) {
        setChannels(templateChannels)
      }
    }, 250),
    [setChannels, channel, templateChannels]
  )

  const handleChannel = (channel, isEnabled) => {
    const channelIndex = templateChannels.findIndex(ch => ch.channelId === channel.channelId)

    if (channelIndex >= 0) {
      templateChannels[channelIndex].isEnabled = isEnabled
      setTemplateChannels(
        [...templateChannels]
      )
    } else {
      setTemplateChannels(
        [...templateChannels, { ...channel, isEnabled }]
      )
    }
  }

  return (
    <div className='template-channels'>
      <p className='template-channels__title'>{`${I18n.t('dashboard_assign-template-to')}...`}</p>
      <div className='template-channels__filters'>
        <MultiBrandsAndDelegations
          isClearable
          customClassNameContainer='template-channels__brands-and-delegations-filter'
          placeholder={I18n.t('dashboard_brands-and-delegations')}
          currentBrands={brandsAndDelegationsValue.brands || []}
          currentDelegations={brandsAndDelegationsValue.delegations || []}
          onChange={onFilterBrandsAndDelegation}
        />
        <div className='template-channels__search'>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-search-grey.svg')} alt='Search' />
          </figure>
          <input
            type='text'
            placeholder={`${I18n.t('dashboard_search-number')}...`}
            value={searchValue}
            onChange={({ target: { value } }) => onFilterText(value)}
          />
          {searchValue ? (
            <button onClick={() => onFilterText('')}>
              <figure>
                <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' />
              </figure>
            </button>
          ) : null}
        </div>
      </div>
      {channels?.length ? (
        <div className='template-channels__table-container'>
          <table className='template-channels__table'>
            <thead>
              <tr>
                <th>
                  <span className='template-channels__table-header-title'>
                    {I18n.t('dashboard_assign')}
                  </span>
                </th>
                <th>
                  <span className='template-channels__table-header-title'>
                    {I18n.t('dashboard_number')}
                  </span>
                </th>
                <th>
                  <span className='template-channels__table-header-title'>
                    {I18n.t('dashboard_state')}
                  </span>
                </th>
                <th>
                  <span className='template-channels__table-header-title'>
                    {I18n.t('dashboard_brand')}
                  </span>
                </th>
                <th>
                  <span className='template-channels__table-header-title'>
                    {I18n.t('dashboard_delegation')}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {channels.map((channel, index) => (
                <tr key={index}>
                  <td>
                    <InputControls
                      value={channel.isEnabled}
                      onChange={value => handleChannel(channel, value)}
                    />
                  </td>
                  <td>
                    <strong
                      className='template-channels__channel-text text-ellipsis'
                    >
                      {channel.channelName}
                    </strong>
                  </td>
                  <td>
                    <QualityStatus
                      templateId={channel.templateId}
                      status={channel.status}
                      quality={channel.qualityStatus}
                      reason={channel.reason}
                      error={channel.errorApi ? {
                        text: I18n.t('dashboard_deactivated-number'),
                        tooltip: channel.errorApi
                      } : null}
                    />
                  </td>
                  <td>
                    <span
                      className='template-channels__text text-ellipsis'
                      title={channel.brandName}
                    >
                      {channel.brandName}
                    </span>
                  </td>
                  <td>
                    <span
                      className='template-channels__text text-ellipsis'
                      title={channel.delegationName}
                    >
                      {channel.delegationName}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className='template-channels__text-info'>
          {I18n.t('dashboard_conversations_noResultsFilter')}
        </p>
      )}
    </div>
  )
}

export default TemplateChannels
